import {useReversalService} from '../../service/reversal/index'

const useReplaceForm = () => {
    const {updateReplaceForm} = useReversalService()
  const updateFormArea = async (data: any) => {
    const res = await updateReplaceForm(data)
      return res
  };
  return {
    updateFormArea,
  };
};

export default useReplaceForm;
